<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ props }">
      <button v-bind="props" class="add-button">+</button>
    </template>
    <v-form v-model="form" @submit.prevent="onSubmit">
      <v-card class="modal-card">
        <div class='modal-title'>
          <p>신규 작성</p>
          <button @click="closeDialog">X</button>
        </div>
        <div class="modal-content">
          <p class="modal-label">제목</p>
          <v-text-field v-model="title" :readonly="loading" :rules="[required]" clearable label="제목을 입력하세요"></v-text-field>
          <p class="modal-label">동영상 URL</p>
          <v-text-field v-model="videoUrl" :readonly="loading" :rules="[required]" clearable label="가이드 동영상 URL을 입력하세요"></v-text-field>
        </div>
        <v-card-actions>
          <v-btn :loading="loading" block size="large" type="submit" variant="elevated">완료</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { ref } from 'vue';
import * as guideApi from '@/api/guide';

export default {
  emits: ['submitted'],
  setup(props, { emit }) {
    const dialog = ref(false);
    const form = ref(false);
    const loading = ref(false);
    const title = ref('');
    const videoUrl = ref('');

    const closeDialog = () => {
      dialog.value = false;
    };

    const onSubmit = async () => {
      if (!form.value) return;

      loading.value = true;
      try {
        await guideApi.postGuide({
          title: title.value,
          videoLink: videoUrl.value,
          videoName: title.value,
        });
        emit('submitted');
        closeDialog();
      } catch (error) {
        console.error("가이드 등록 실패:", error);
        alert("가이드 등록에 실패했습니다.");
      } finally {
        loading.value = false;
      }
    };

    const required = (v) => !!v || '해당 필드가 채워져야합니다';

    return {
      dialog,
      form,
      loading,
      title,
      videoUrl,
      closeDialog,
      onSubmit,
      required,
    };
  },
};
</script>

<style scoped>
.add-button {
  width: 24px;
  height: 24px;
  color: #ECEFF1;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-card {
  background-color: #78909C;
  color: #ECEFF1;
}
.modal-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  font-size: 18px;
}
.modal-content {
  padding: 0 24px;
}
.modal-label {
  font-size: 14px;
  margin-bottom: 4px;
}
</style>